import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const LOGO_URL = "/logo-white.png";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/5 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 overflow-hidden rounded">
                <img src={LOGO_URL} alt="Artificial Mind" className="w-full h-full object-contain" />
              </div>
              <span className="font-heading font-bold text-lg tracking-wide">ARTIFICIAL MIND</span>
            </div>
            <p className="text-slate-500 text-sm leading-relaxed max-w-sm">
              Transitioning traditional enterprises into the era of Artificial Intelligence. We build AI/ML and Deep Learning solutions that matter.
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-3">
            <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-bold mb-6">Navigation</h4>
            <div className="space-y-3">
              {[
                { path: '/services', label: 'Services' },
                { path: '/industries', label: 'Industries' },
                { path: '/case-studies', label: 'Case Studies' },
                { path: '/about', label: 'About' },
                { path: '/contact', label: 'Contact' },
              ].map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                  className="block text-slate-400 hover:text-white text-sm transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Industries */}
          <div className="md:col-span-4">
            <h4 className="text-xs uppercase tracking-[0.2em] text-slate-500 font-bold mb-6">Industries</h4>
            <div className="flex flex-wrap gap-2">
              {['Government', 'Defense', 'Energy', 'Oil & Gas', 'Railways', 'Satellite', 'Education'].map((ind) => (
                <span key={ind} className="text-xs text-slate-500 border border-white/10 px-3 py-1.5">
                  {ind}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 md:mt-20 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-xs text-slate-600">
            &copy; {new Date().getFullYear()} Artificial Mind. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/admin"
              data-testid="footer-admin-link"
              className="text-xs text-slate-700 hover:text-slate-400 uppercase tracking-widest transition-colors duration-200"
            >
              Admin
            </Link>
            <a
              href="/contact"
              data-testid="footer-cta"
              className="inline-flex items-center gap-1 text-xs text-slate-400 hover:text-white uppercase tracking-widest transition-colors duration-200"
            >
              Start a conversation <ArrowUpRight size={12} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
